import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import OpcoesPaginacao from '../comum/OpcoesPaginacao'
import alterarRegistrosPorPagina from '../../actions/centro-custo/alterarRegistrosPorPaginaCentroCusto'
import determinarPaginaAtual from '../../actions/centro-custo/determinarPaginaAtualCentroCusto'

export class PaginacaoCentroCusto extends Component {
  render () {
    return <OpcoesPaginacao
      registrosPorPagina={this.props.registrosPorPagina}
      numeroElementos={this.props.total}
      paginaAtual={this.props.paginaAtual}
      determinarPaginaAtual={this.props.determinarPaginaAtual}
      alterarRegistrosPorPagina={this.props.alterarRegistrosPorPagina}/>
  }
}

export function mapDispatchToProps (dispatch) {
  return bindActionCreators({
    alterarRegistrosPorPagina,
    determinarPaginaAtual
  }, dispatch)
}

export function mapStateToProps (state) {
  return {
    paginaAtual: state.paginaAtualCentroCusto,
    total: state.centroCusto.totalCentroCusto,
    registrosPorPagina: state.registrosPorPaginaCentroCusto
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PaginacaoCentroCusto)
